import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Construction, ArrowLeft } from 'lucide-react';
import { Sidebar } from '@/components/common/Sidebar';
import { useAuth } from '@/hooks/useAuth';

export function ComingSoonPage({ title }: { title: string }) {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-neutral-950 flex">
      {/* Sidebar */}
      <Sidebar
        userRole={user.role}
        userName={user.name}
        onLogout={async () => {
          navigate('/login');
        }}
      />

      {/* Main content */}
      <div className="flex-1 flex flex-col items-center justify-center p-8 bg-white dark:bg-neutral-950">
        <div className="max-w-md w-full text-center space-y-6">
          <div className="w-20 h-20 bg-teal-100 dark:bg-teal-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
            <Construction className="w-10 h-10 text-teal-600 dark:text-teal-400" />
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            {title}
          </h1>
          
          <p className="text-gray-500 dark:text-gray-400 text-lg">
            Esta página ainda está em desenvolvimento. Estamos trabalhando para trazer esta funcionalidade em breve!
          </p>

          <Button 
            onClick={() => navigate('/dashboard')}
            className="mt-8 bg-teal-600 hover:bg-teal-700 text-white inline-flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Voltar ao Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
}
